import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=04e54630&scoped=true"
import script from "./Favorites.vue?vue&type=script&lang=js"
export * from "./Favorites.vue?vue&type=script&lang=js"
import style0 from "./Favorites.vue?vue&type=style&index=0&id=04e54630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e54630",
  null
  
)

export default component.exports